import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './lang/zh-CN'
import enUS from './lang/en-US'
Vue.use(VueI18n)

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

// 从本地存储获取语言设置，默认跟随浏览器
const savedLang = localStorage.getItem('lang')
const browserLang = navigator.language || 'zh-CN'
const defaultLang = savedLang || (browserLang.startsWith('zh') ? 'zh-CN' : 'en-US')

const i18n = new VueI18n({
  locale: defaultLang, // 设置默认语言
  fallbackLocale: 'en-US', // 设置回退语言
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/locales/index.js